<script lang="ts">
  import {createEventDispatcher, getContext} from 'svelte';
  import {SERVICES} from '@/const/services';
  import Modal from '@/widgets/Modal.svelte';
  import Button from '@/widgets/Button.svelte';
  import lang from '../LoginPage.lang';

  const prefixUrl = `${SERVICES.IMG_URL}/v1`;

  export let LG = null;
  const dispatch = createEventDispatcher();
  const staticIconMap = {
    verifyIdentity: `${prefixUrl}/510c30a1-c6c4-4282-95dc-38a14dfba98f/passkey-failed.png`
  }
  let CurrentLG = LG || getContext('LG');

  function handlePasskeyClick(){
    dispatch('success', {type:'once'});
  }

  function handlePwdClick(){
    dispatch('success', {type:'pwd'});
  }

  function handleCloseEvent() {
    dispatch('close', null);
  }

</script>

<style>
  .wrap-pk :global(.modal-mask){
    z-index: 1000000
  }
  :global(.enable-modal.modal .modal-content){
    padding: 32px;
  }
  .enable-wrap .ffy{
    font-family: 'HarmonyOS Sans';
  }
  .enable-wrap .banner{
    width: 120px;
    height: 120px;
  }
  .enable-wrap .banner img{
    width: inherit;
    height: inherit;
  }
  .enable-wrap :global(.enable-btn) {
    width: 100%;
    min-width: unset;
    font-family: 'HarmonyOS Sans';
  }
  .enable-wrap :global(.enable-btn:hover) {
    opacity: 0.8;
  }
  .enable-wrap :global(.enable-btn:focus) {
    opacity: 0.8;
    background-color: var(--blue);
    color: var(--TW);
  }
</style>

<div class='wrap-pk'>
<Modal class='enable-modal' showCloseIcon={true} visible style="width: 480px;" on:close={handleCloseEvent}>
  <div class='enable-wrap'>
    <div class='ffy T1 f24 fw3'>{LG(lang.PasskeyFailed)}</div>
    <div class='tc mt24'>
      <span class='banner'>
        <img src={staticIconMap.verifyIdentity}/>
      </span>
    </div>
    <div class='ffy T1 f14 fw1 pv24'>{LG(lang.PasskeyFailedDesc)}</div>
    <div>
      <Button type='primary' class='ffy enable-btn mt12' newRadius on:click={handlePasskeyClick}>{LG(lang.TryAgain)}</Button>
    </div>
    <div>
      <Button class='ffy enable-btn T1 mt12' newRadius on:click={handlePwdClick}>{LG(lang.LoginWithPwd)}</Button>
    </div>
  </div>
</Modal>
</div>
